<template>
    <v-sheet class="mt-n40 mt-lg-n60">
        <question-item v-for="(value, index) in questions" :key="value.question._id" v-bind="{ value, index }" @input="updateItem" class="mt-40 mt-lg-60" />
    </v-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input, RECRUITMENT_QUESTION_TYPES } from "@/assets/variables";

import QuestionItem from "@/components/client/application/questions/question-item.vue";
import VerticalTableRow from "@/components/dumb/vertical-table-row.vue";

export default {
    components: {
        QuestionItem,
        VerticalTableRow,
    },
    props: {
        value: { type: Array, default: () => [] }, // questions
        _recruitment: { type: String, default: null },
    },
    data: () => ({
        questions: [],

        attrs_input,
        RECRUITMENT_QUESTION_TYPES,
    }),
    mounted() {
        this.sync();
        this.init();
    },
    watch: {
        _recruitment() {
            this.sync();
            this.init();
        },
    },
    methods: {
        sync() {
            this.questions = [...this.value];
        },
        emit() {
            this.$emit("input", [...this.questions]);
        },
        async init() {
            if (this._recruitment) {
                const { recruitment: { questions } = {} } = await api.v1.recruitments.get({ _id: this._recruitment });

                this.questions = questions.map((question) => ({ ...(this.value.find((item) => question._id == item?.question?._id) || {}), question }));

                this.emit();
            }
        },
        updateItem(item) {
            const index = this.questions.findIndex(({ question }) => question?._id == item?.question?._id);
            if (0 <= index) this.questions.splice(index, 1, item);
            this.emit();
        },
    },
};
</script>
